import { useCallback, useSyncExternalStore } from 'react'
import { deviceStorage, STORAGE_KEYS } from '@/shared/lib/storage'
import { useSession } from './useAuth'
import type { OrgRef } from '@/shared/types/api'

function getSavedOrgId() {
  return deviceStorage.get(STORAGE_KEYS.crossSession.lastOrg) ?? ''
}

let currentOrgId = getSavedOrgId()
const listeners = new Set<() => void>()

function subscribe(cb: () => void) {
  listeners.add(cb)
  return () => {
    listeners.delete(cb)
  }
}

function getSnapshot() {
  return currentOrgId
}

function setOrgId(id: string) {
  currentOrgId = id
  deviceStorage.set(STORAGE_KEYS.crossSession.lastOrg, id)
  listeners.forEach((cb) => cb())
}

export function useCurrentOrg() {
  const { data: user } = useSession()
  const orgs = user?.orgs ?? []
  const savedId = useSyncExternalStore(subscribe, getSnapshot)
  const currentOrg =
    orgs.find((o) => o._id === savedId) ?? orgs[orgs.length - 1] ?? null

  const switchOrg = useCallback((org: OrgRef) => {
    setOrgId(org._id)
  }, [])

  return { currentOrg, orgs, switchOrg }
}
